// ShamsiDatePicker.js
import React from "react";
import DatePicker from "react-multi-date-picker";
import { persian, customLocale } from "./customLocale";
import "./ShamsiDatePicker.css";
import { TextField } from "@mui/material";
const ShamsiDatePicker = ({ value, onChange, label, placeholder, onFocus, disabled, minDate, maxDate }) => {
  return (
    <div>
      {
        label && (
          <label>{label}</label>
        )
      }

      <DatePicker
        value={value}
        onChange={onChange}
        calendar={persian}
        locale={customLocale}
        format="YYYY/MM/DD"
        placeholder={placeholder}
        onOpenPickNewDate={false}
        minDate={minDate}
        maxDate={maxDate}
        render={<TextField
          fullWidth
          label={placeholder || ""}
          placeholder={placeholder || ""}
          value={value}
          onChange={onChange}
          size="small"
          disabled={disabled}
          autoComplete={"off"}
        />}
      />
    </div>
  );
};

export default ShamsiDatePicker;
